<template>
  <div class="leads-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.leads-web'), disabled: true },
        { title: this.$t('state-machines.title'), disabled: true }
      ]">
    </Breadcrumbs>
    <br/>

    <div v-if="isLoading" class="my-4 py-4 d-flex flex-column justify-content-center align-items-center">
      <h6><b>{{$t('state-machines.is_loading')}}</b></h6>
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
    <div v-if="!isLoading && stateMachines && stateMachines.length === 0">
      <h4>{{$t('state-machines.no_state_machines')}}</h4>
    </div>
    <StateMachine v-if="!isLoading && stateMachines && stateMachines.length > 0"
    :stateMachine="selectedStateMachine"
    :stateMachineStates="stateMachinesStates"/>

  </div>
</template>

<script>

import Breadcrumbs from '@/components/common/Breadcrumbs'
import StateMachine from '@/components/leads-web/state-machines/StateMachine'
import { LeadsWebService } from '@/api/LeadsWebService'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'

export default {
  components: {
    LoadingAnimation,
    StateMachine,
    Breadcrumbs,

  },
  data () {
    return {
      isLoading: false,
      stateMachines: null,
      selectedStateMachine: null,
      stateMachinesStates: null
    }
  },
  mounted () {
    this.getStateMachines()
  },
  methods: {
    getStateMachines: function () {
      this.isLoading = true
      LeadsWebService.getLeadFlows().then(resp => {
        this.stateMachines = resp.data
        this.selectedStateMachine = this.stateMachines[this.stateMachines.length - 1]
        this.getStateMachineStates()
      }).catch(err => {
        this.showToast(this.$t('state-machines.lead_flows_fetch_error'), this.$store.state.errorToastOptions)
        console.log(err)
        this.isLoading = false
      })
    },

    getStateMachineStates: function () {
      LeadsWebService.getLeadFlowStatesByLeadFlowId(this.selectedStateMachine.id).then(resp => {
        this.stateMachinesStates = resp.data
        this.isLoading = false
      }).catch(err => {
        this.showToast(this.$t('state-machines.lead_flow_states_fetch_error'), this.$store.state.errorToastOptions)
        console.log(err)
        this.isLoading = false
      })
    }
  }
}

</script>

<style lang="scss">

</style>
